import AssetService from '@/services/AssetService';

export const PopupDead = ({ onClose = () => {}, stage = 0 }) => {
  const { t } = useTranslation();

  const popup = useAppStore((state) => state.popup);
  const setPopup = useAppStore((state) => state.setPopup);
  const crashedData = useGameStore((state) => state.crashedData);

  const [isPlaying, setIsPlaying] = useState(false);

  const show = popup == 'dead';

  useEffect(() => {
    if (!show) return;
    if (isPlaying) return;
    let sfx = AssetService.getAsset('s_jeremy_lose');
    sfx.play();
    setIsPlaying(true);
    setTimeout(() => {
      setIsPlaying(false);
    }, sfx.duration * 1000);
  }, [show]);

  const _onClose = useCallback(() => {
    if (isPlaying) return;
    console.log('PopupDead._onClose');
    setPopup(null);
    onClose();
    AssetService.getAsset('s_button').play();
  }, [onClose, isPlaying]);

  const stage3Image =
    crashedData === 'cloud'
      ? '/assets/images-next/fail2.webp'
      : '/assets/images-next/fail3.png';

  const heading =
    stage == 2
      ? t(`game.dead.heading-collision.${crashedData}`)
      : t(`game.dead.heading.${stage}`);

  return (
    <Popup
      popupId="dead"
      className="frame-brown font-gellix text-[1.8rem] leading-[1.18] font-semibold tracking-[0.02em]"
      onClose={_onClose}
      closable={!isPlaying}
    >
      {/* <img src="/assets/images-next/jeremy-dead.webp" /> */}

      <div className="img w-[60%]">
        {stage == 0 && <img src="/assets/images-next/fail0.webp" />}
        {stage == 1 && <img src="/assets/images-next/fail1.webp" />}
        {stage == 2 && <img src={stage3Image} />}
      </div>

      <h2 className="typo-h2 mt-2">{heading}</h2>

      <div className="my-3 text-center whitespace-pre-line">
        {t('game.dead.desc')}
      </div>

      <button
        className="btn-primary"
        onClick={_onClose}
      >
        {t('game.dead.cta')}
      </button>
    </Popup>
  );
};
